export const reviewSectionsData = [
    {
        id: "interior",
        title: "Interior"
    },
    {
        id: "performance",
        title: "Performance"
    },
    {
        id: "practicality",
        title: "Practicality"
    },
    {
        id: "running-costs",
        title: "Running costs"
    },
    {
        id: "verdict",
        title: "Verdict"
    }
];
